module.exports = __webpack_public_path__ + "img/03_Uebersicht-Oeffnungsarten@2x.a3389e5b.jpg";